<template>
    <g clip-path="url(#clip001)">
        <path d="M2 23L14 2L26 23H2Z" stroke="white" stroke-width="2"></path>
        <path d="M14 20V18" stroke="white" stroke-width="2"></path>
        <path d="M14 16.5V9" stroke="white" stroke-width="2"></path>
    </g>
    <defs>
        <clipPath id="clip001">
            <rect width="28" height="28" fill="white"></rect>
        </clipPath>
    </defs>
</template>

<script>
    export default {
        name: 'icon-warning'
    }
</script>